let fbqButtons = $('[data-fbq-track]')
if(fbqButtons.length) {
  fbqButtons.each(function (){
    $(this).click(function (e){
      fbq('track', $(this).attr('data-fbq-track'))
    })
  })
}
